import React, { useState } from 'react';
import { useEffect } from 'react';
import customHeaders, { getSpace } from '../../../../common/headers';
import { useRef } from 'react';
import { useDataTable } from '../../../../common/hooks';
import { TableBox, ButtonBasic } from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../../../store/general';
import './ModalRublesTable.scss'
import { FilterArticles } from '../../../FilterArticles/FilterArticles';
import { StepItem } from '../../../StepItem/StepItem';
import { usePushNotifications } from '../../../../common/pushNotification';
import { ModalComponent } from '../../ModalComponent/ModalComponent';
import { useResponseHandler } from '../../../../common/auth';

interface ModalRulesTableProps {
    setIsModal: (e: boolean) => void
    selectedItems: any
    setSelectedItems: (e: any) => void
    filterValues: any,
    setFilterValues: (e: any) => void
    filterData: any
}

type PaginatorType = {
    setTotal: (total: number) => void;
    page: number
    limit: number
    reset: () => void
    // добавь сюда другие поля, если нужно
};

const ModalRulesTable = ({
    setIsModal,
    filterValues,
    setSelectedItems,
    setFilterValues,
}: ModalRulesTableProps) => {
    // Рефы
    const fileInputRef = useRef(null);
    const refContainer = useRef(null);

    // Обработка ошибок
    const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();
    const { handleTableResponse, handleRequestError } = useResponseHandler();

    const selectedMarketplace: string[] = filterValues?.['12']?.map(({ value }) => value)
    const selectedApi: string[] = filterValues?.['13']?.map(({ value }) => value)
    const selectedBrand: string[] = filterValues?.['14']?.map(({ value }) => value)
    const selectedCategory: string[] = filterValues?.['15']?.map(({ value }) => value)
    const selectedProduct: string[] = filterValues?.['22']?.map(({ value }) => value)

    const [initialFilterValue, setInitialFilterValue] = useState((selectedProduct?.length && selectedProduct[0] != 'all') ? selectedProduct : [])
    const [filterValue, setFilterValue] = useState((selectedProduct?.length && selectedProduct[0] != 'all') ? selectedProduct : []);

    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const paginatorRef = useRef<PaginatorType | null>(null);
    const [setTable, tableProps, setTableFuncs]: any = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    )
    const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
    const [loadingUpload, setLoadingUpload] = useState(false)

    // Выбор чекбоксов в таблице
    const handleCheck = (data: any) => {
        setSelectedItems(data.map(({ name, product_id }) => ({
            label: name,
            value: product_id
        })));
    };

    // Получение таблицы
    const fetchTableData = (params = [], abortController = new AbortController()) => {

        let sort
        let filtersParam
        if (params) {
            [sort, filtersParam] = params;
        }

        setLoading(true);

        let url = `https://apps0.ecomru.ru:4420/api/v1/marketing/action/rule/file/product/table${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
            : ''
            }`

        const body = JSON.stringify({
            page: paginatorRef.current?.page,
            limit: paginatorRef.current?.limit,
            filters: filtersParam,
            api_id_list: selectedApi,
            product_id_list: filterValue,
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => setTable(json))
            .catch(handleRequestError)
            .finally(() => {
                setLoading(false);
                if (abortController.signal.aborted) {
                    return;
                }
            });
    };

    // Загрузить шаблон
    const onUploadFileToPromotion = (file) => {
        if (!file) {
            return;
        }
        setLoadingUpload(true)
        addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')

        const url = `https://apps1.ecomru.ru:4448/api/v2/promotion/rule/file/validate`;

        const formData = new FormData();
        formData.append('file', file);

        const updatedHeaders = { ...headers };
        delete updatedHeaders['Content-Type'];

        fetch(url, {
            method: 'POST',
            headers: updatedHeaders,
            body: formData,
        })
            .then(async (res) => {
                // Пытаемся распарсить ответ от сервера как JSON
                const data = await res.json();

                if (!res.ok) {
                    const errorMessage = data.detail || res.statusText;
                    addErrorPush(`Ошибка загрузки: ${errorMessage}`);
                    throw new Error(`Upload failed: ${res.status} ${errorMessage}`);
                }
                return data;
            })
            .then((data) => {
                addSuccessPush('Файл успешно загружен')
                if (fileInputRef.current) fileInputRef.current.value = ''
                setFilterValue(data?.product_ids)
                setInitialFilterValue(data?.product_ids)
                // setTimeout(() => fetchTableDataPrice(), 1000)
            })
            .catch((err) => {
                console.error(err);
                if (fileInputRef.current) fileInputRef.current.value = ''
            })
            .finally(() => {
                setLoadingUpload(false)
            });
    };

    const handleFileChangeLink = async (e) => {
        onUploadFileToPromotion(e.target.files[0])
    };

    useEffect(() => {
        setSelectedItems([])
        const current_filter = filterValue?.map((el) => ({ label: '', value: el }))
        setInitialFilterValue(filterValue)
        setFilterValues(prev => (
            {
                ...prev,
                22: current_filter || []
            }
        ))

        setTimeout(() => fetchTableData(), 0)
    }, [filterValue]);

    return (
        <>
            <ModalComponent
                title='Выбор по товарам'
                onClose={(e: boolean) => setIsModal(false)}
                style={{ maxWidth: '1200px' }}
                child={
                    <div className="modal-rules-table">

                        {!filterValue?.length && <StepItem
                            title='Выбраны "Все товары"'
                            description={<>Если хотите выбрать часть товаров, то: <br />
                                Чтобы загрузить вручную - нажмите <span style={{ color: '#1890FF' }}>"Фильтр по артикулу"</span><br />
                                Чтобы загрузить из файла - нажмите <span style={{ color: '#22C55E' }}>"Загрузить"</span>
                            </> as any}
                        />}

                        <div ref={refContainer} className='modal-rules-table__content'>
                            <TableBox
                                {...tableProps}
                                refContainer={refContainer}
                                ref={paginatorRef}
                                paginator={true}
                                onCheck={(e) => handleCheck(e)}
                                fetchCallback={fetchTableData}
                                child={<>
                                    <ButtonBasic
                                        blue
                                        text='Шаблон загрузки Excel'
                                        size='32px'
                                        onClick={() => {
                                            const link = document.createElement('a');
                                            link.href = 'https://file.ecomru.ru:4453/api/v1/file/download/c656bc1a-1482-42a9-a674-9e6b5062ccab';
                                            link.download = 'template.xlsx'; // Имя файла
                                            link.style.display = 'none'; // Скрываем ссылку
                                            document.body.appendChild(link);
                                            link.click();
                                        }}
                                    />

                                    <div className='modal-rules-table__btn-upload'>
                                        <ButtonBasic
                                            green
                                            width='auto'
                                            text='Загрузить'
                                            size='32px'
                                            loading={loadingUpload}
                                        />

                                        <input
                                            type="file"
                                            id="fileInput"
                                            onChange={handleFileChangeLink}
                                            ref={fileInputRef}
                                        // style={{ display: 'none' }}
                                        />
                                    </div>

                                    <FilterArticles
                                        filterValue={filterValue as any}
                                        setFilterValue={setFilterValue}
                                    />
                                </>}
                            />
                        </div>
                    </div>
                }
            />
        </>
    );
}

export { ModalRulesTable }